<template>
	<main>
		<eia-form-group
			class="eia-stage-five__user-name"
			id="user-name"
			variation="stacked">
			<div class="eia-stage-five__form-group-header"
				slot="label">
				<eia-heading
					level="h3">
					Tell us your name
				</eia-heading>
				<span>This information is required so that we can tailor the summary response to you as the user.</span>
			</div>

			<eia-validated-input
				id="user-name"
				type="text"
				:validators="[]"
				:show-error-indentation="true"
				placeholder="E.g. John Smith"
				:value="name"
				@input="onUserNameInput">
			</eia-validated-input>
		</eia-form-group>

		<eia-form-group
			class="eia-stage-five__user-email"
			id="user-email"
			variation="stacked">
			<div class="eia-stage-five__form-group-header"
				slot="label">
				<eia-heading
					level="h3">
					Email Address
				</eia-heading>
				<span>We ask for your email so we can send you a copy of the report</span>
			</div>

			<eia-validated-input
				id="user-email"
				type="text"
				:validators="emailValidators"
				:show-error-indentation="true"
				placeholder="name@example.com"
				:value="email"
				@input="onUserEmailInput"
				@error="onUserEmailError">
			</eia-validated-input>
		</eia-form-group>

		<eia-form-group
			class="eia-stage-five__company-name"
			id="company-name"
			variation="stacked">
			<div class="eia-stage-five__form-group-header"
				slot="label">
				<eia-heading
					level="h3">
					Company Name (optional)
				</eia-heading>
				<span>This information allows us to understand the nature of the users of the tool to tailor future development of it.</span>
			</div>

			<eia-validated-input
				id="company-name"
				type="text"
				:validators="[]"
				:show-error-indentation="true"
				placeholder="Company Name"
				:value="companyName"
				@input="onUserCompanyNameInput">
			</eia-validated-input>
		</eia-form-group>
	</main>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { email } from '@/utils/validators';

export default {
	name: 'eia-your-details-stage',

	beforeMount(){
		this.emit();
	},

	data() {
		return {
			hasSiteArea: null,
			name: this.$store.state.stages.userDetails.name,
			email: this.$store.state.stages.userDetails.email,
			companyName: this.$store.state.stages.userDetails.companyName,
			emailValidators: [ email ],
		};
	},

	computed: {
		...mapGetters( 'stages', [ 'userDetails', 'userDetailsValid' ] ),
	},

	watch: {
		userDetailsValid(){
			this.emit();
		},
	},

	methods: {
		...mapMutations( 'stages', [
			'setUserDetailsValid',
			'setUserName',
			'setUserEmail',
			'setUserCompanyName',
		] ),

		onUserNameInput( value, valid ) {
			this.setUserName( valid ? value : '' );
			this.setUserDetailsValid();
		},

		onUserEmailInput( value, valid ) {
			this.setUserEmail( valid ? value : '' );
			this.setUserDetailsValid();
		},

		onUserCompanyNameInput( value ) {
			this.setUserCompanyName( value );
			this.setUserDetailsValid();
		},

		onUserEmailError() {
			this.setUserDetailsValid();
		},

		emit(){
			this.$emit( 'input', this.userDetailsValid ? true : null );
		},
	},
};
</script>

<style lang="scss">
.eia-stage-five {
	main {
		margin: 32px 0;
	}

	&__form-group-header {
		margin-bottom: 4px;
	}

	.eia-form-group {
		margin: 32px 0;

		.eia-input {
			width: 400px;
			max-width: 100%;
		}
	}
}
</style>
